import React from 'react'
import { NavLink } from 'react-router-dom';
import '../../styles/style.css'
import logo from '../../assets/images/EZ_LEISURE_LOGO.svg'
import ProfileHeaderIcon from './ProfileHeaderIcon';


export default function Header(props) {
    return (
        <section id='header' className="header">
            <div className="container">
                <nav className="navbar navbar-expand-lg navbar-light bg-light login-header">
                <a className="navbar-brand" href="/">
                    <img className="img-fluid" src={logo} />
                </a>
                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={() => {
                        var nav = document.getElementById('navbar1');
                        if(nav.className === 'collapse navbar-collapse'){
                            nav.className = 'navbar-collapse';
                        }else{
                            nav.className='collapse navbar-collapse';
                        }
                    }}
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbar1">
                    <ul className="navbar-nav ml-auto">
                        {props.navBarData && props.navBarData.map((item,index) => {
                            return(
                                <li key={index} onClick={(e) => {
                                    if(e.target.text === 'Reserve Now')
                                    {
                                        setTimeout(() =>{
                                            var bookNow = document.getElementById('bookNow');
                                            bookNow && bookNow.focus();
                                        }, 500);
                                    }
                                }} className="nav-item">
                                    {item.icon ?  
                                    <NavLink to={item.to} className="nav-link">
                                        {item.icon}
                                    </NavLink>
                                        :
                                    item.label === 'profileIcon'
                                        ?
                                    <NavLink to={item.to} className="nav-link">
                                        <ProfileHeaderIcon src={props.profileImage} />
                                    </NavLink>
                                        :
                                    <NavLink to={item.to} className="nav-link">
                                    {item.label}
                                    </NavLink>
                                }
                                </li>
                            )
                        })}
                    </ul>
                </div>
                </nav>
            </div>
        </section>
    )
}
